exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.add-member .ant-modal-footer {\n  display: none;\n}\n.ant-form-item-control-wrapper {\n  width: 97%;\n}\n.has-error .ant-form-explain {\n  margin-left: 44px;\n}\n", ""]);

// exports
